import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'

class TeamMemberFormAE extends React.Component {
    // static PropTypes = {
    //     teamObj: PropTypes.object.isRequired,
    //     onSave: PropTypes.func.isRequired,
    // }

    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        const teamObj = this.props.teamObj;

        if (teamObj.members_AE !== undefined && teamObj.members_AE !== null && teamObj.members_AE !== '') 
            teamObj.member_AE_Id = teamObj.member_AE_Id;
        
        else 
            teamObj.member_AE_Id = teamObj.id;        

        this.props.onSave({ ...teamObj });
    }

    renderMember(studioName) {
        return (
            <div>
                <div className="member-details two-cols">
                    <div className="control">
                        <label>First Name</label>
                        <span>{this.props.teamObj.employee.firstName}</span>
                    </div>
                    <div className="control">
                        <label>Last Name</label>
                        <span>{this.props.teamObj.employee.lastName}</span>
                    </div>
                </div>

                <div className="member-details two-cols">
                    <div className="control">
                        <label>Discipline</label>
                        <span>{this.props.teamObj.lkp_Members_Discipline_AE && this.props.teamObj.lkp_Members_Discipline_AE.memberDiscipline}</span>
                    </div>
                    <div className="control">
                        <label>Studio</label>
                        <span>{studioName}</span>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        var studio = null; 
        //var studioMult = [];  
        var studioName = null;

        // members and leaders
      //  if (this.props.teamObj.studio_Members_AE.length === 1)
      if (this.props.teamObj.studio_Members_AE.length > 0)
            studio = _.find(this.props.teamObj.studio_Members_AE, { member_AE_Id: this.props.teamObj.id });

        // if a member belongs to more than 1 studio
        // else if (this.props.teamObj.studio_Members_AE.length > 1)
        //     studioMult = _.filter(this.props.teamObj.studio_Members_AE, { member_AE_Id: this.props.teamObj.id });
       
        if (studio !== null)
            studioName = studio.lkp_Studio_AE.studio;        

            // TODO: This is a working code for a member that belongs so multiple studios. For the next release
        // if (studioMult.length > 0)
        // {
        //     studioName = studioMult[0].lkp_Studio_AE.studio;
        //     for(var i = 1; i < studioMult.length; i++)
        //     {
        //         studioName += ", " + studioMult[i].lkp_Studio_AE.studio;
        //     }
        // }
     
        return (
            <form onSubmit={this.handleSubmit}>
                <div>
                     {this.renderMember(studioName)} 

                    <button className="btn-update">
                        Add
                 </button>
                </div>
            </form>
        )
    }
}

TeamMemberFormAE.propTypes = {
    teamObj: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired
};

export default TeamMemberFormAE;